export const mediaCdnReplace = (url: string) => {
  if (!url) {
    return url
  }
  return url.replaceAll('https://media.reshet.tv', 'https://media3.reshet.tv')
}
